import { render, staticRenderFns } from "./SettingsMaterialItemDetails.vue?vue&type=template&id=7045b203&scoped=true&"
import script from "./SettingsMaterialItemDetails.vue?vue&type=script&lang=ts&"
export * from "./SettingsMaterialItemDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7045b203",
  null
  
)

export default component.exports